import camelCase from 'camelcase'
import fastSafeStringify from 'fast-safe-stringify'

// stringify that can handle exotic objects e.g. with cyclical references
// useful for debugging and stringifying javascript errors etc.
export const stringify = (
  obj: unknown,
  replacer?: Parameters<typeof JSON.stringify>[1],
  space?: Parameters<typeof JSON.stringify>[2],
): string => {
  const safeReplacer = typeof replacer === 'function' ? replacer : undefined

  try {
    return JSON.stringify(obj, replacer, space)
  } catch {
    return fastSafeStringify(obj, safeReplacer, space, {
      depthLimit: 4,
      edgesLimit: 50,
    })
  }
}

// convert python style snake_case to camelCase in json objects
// Functions and dates count as objects here, so they come back as `{}`
export const camelConverter = (obj: unknown): unknown => {
  if (Array.isArray(obj)) return obj.map(item => camelConverter(item))
  if (obj != null && (typeof obj === 'object' || typeof obj === 'function'))
    return Object.fromEntries(
      Object.entries(obj).map(([key, val]) => [
        key.match(/_/) ? camelCase(key) : key,
        camelConverter(val),
      ]),
    )
  return obj
}
